import { useRouter } from 'next/router';
import useUserStore from '@/stores/user.store';

const BattlesLobbyHeader = () => {
    const { isAuthed } = useUserStore((state) => state);
    const router = useRouter();

    return (
        <section className="surface flex flex-wrap items-center justify-between gap-3 px-4 py-3">
            <div className="flex items-center gap-2.5 min-w-0">
                <span
                    className="w-1 h-[34px] rounded-sm shrink-0"
                    style={{
                        background: 'linear-gradient(#8b6dff,#3ad6ff)',
                        boxShadow: '0 0 12px #8b6dff',
                    }}
                />
                <div className="flex flex-col leading-tight min-w-0">
                    <h1 className="font-chat-nick text-[15px] font-extrabold tracking-[0.10em] uppercase text-text_main">
                        Crate Battles
                    </h1>
                    <span className="text-[11.5px] text-text_3 font-medium truncate">
                        Battle against other bandits or unbox crates together.
                    </span>
                </div>
            </div>

            {isAuthed ? (
                <button
                    onClick={() => router.push('/casebattles/create')}
                    className="group relative overflow-hidden inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-[12.5px] font-extrabold tracking-[0.07em] uppercase font-chat-nick hover:-translate-y-0.5 transition-transform"
                    style={{
                        background: 'linear-gradient(135deg, #8b6dff, #3ad6ff)',
                        boxShadow:
                            'inset 0 1px 0 rgba(255,255,255,0.35), 0 0 22px -4px rgba(139,109,255,0.7), 0 8px 20px -6px rgba(58,214,255,0.5)',
                    }}
                >
                    <span
                        aria-hidden
                        className="pointer-events-none absolute inset-0 -translate-x-[120%] group-hover:translate-x-[120%] transition-transform duration-[700ms] ease-out"
                        style={{
                            background:
                                'linear-gradient(100deg, transparent 30%, rgba(255,255,255,0.5), transparent 70%)',
                        }}
                    />
                    <svg
                        viewBox="0 0 24 24"
                        className="relative w-3.5 h-3.5 stroke-current fill-none [stroke-width:2.4] [stroke-linecap:round]"
                    >
                        <path d="M12 5v14M5 12h14" />
                    </svg>
                    <span className="relative">Create battle</span>
                </button>
            ) : (
                <span className="w-[180px]" />
            )}
        </section>
    );
};

export default BattlesLobbyHeader;
